import React, { useState } from 'react';

export default function StepSubmit({ form, onSuccess }) {
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const submit = async () => {
    if (loading || submitted) return;
    if (!form?.x || !form?.walletEth) { setStatus('Missing required fields'); return; }
    setLoading(true); setStatus('Submitting...');
    try {
      const res = await fetch('/api/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ x: form.x, walletEth: form.walletEth, proofOfComment: form.proofOfComment || '' }),
      });
      const text = await res.text();
      let data;
      try { data = JSON.parse(text); } catch { data = { status: 'error', message: text }; }
      if (data.status === 'success') {
        setSubmitted(true); setStatus('Submitted successfully ✓'); onSuccess?.();
      } else if (data.status === 'duplicate') {
        setStatus('Already submitted ⚠️');
      } else {
        setStatus('Error: ' + (data.message || 'Unknown error'));
      }
    } catch (err) {
      setStatus('Network error ❌');
    } finally { setLoading(false); }
  };

  return (
    <div>
      <h2 style={{ fontFamily: "'Bangers', cursive", fontSize: '26px', letterSpacing: '1.5px', color: '#3D1F0A', textAlign: 'center', marginBottom: '6px' }}>
        {submitted ? '🎉 YOU\'RE IN!' : 'READY TO SUBMIT?'}
      </h2>
      <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '13px', color: '#6B4A1A', textAlign: 'center', marginBottom: '16px' }}>
        {submitted ? 'Your whitelist spot has been secured.' : 'Review your details before confirming.'}
      </p>

      {/* Summary card */}
      <div style={{
        background: '#FFF9EE', border: '2px solid rgba(61,31,10,0.2)',
        borderRadius: '12px', padding: '14px 16px', marginBottom: '16px',
      }}>
        <p style={{ fontFamily: "'Bangers', cursive", fontSize: '12px', letterSpacing: '1.5px', color: '#C87400', marginBottom: '8px' }}>
          WHAT WE'RE RECORDING:
        </p>
        <div style={{ fontFamily: "'Nunito', sans-serif", fontSize: '12px', color: '#3D1F0A', lineHeight: '2' }}>
          <div><strong style={{ color: '#C87400' }}>𝕏</strong> &nbsp;{form.x}</div>
          <div><strong style={{ color: '#C87400' }}>ETH</strong> &nbsp;<span style={{ wordBreak: 'break-all', fontSize: '11px' }}>{form.walletEth}</span></div>
          {form.proofOfComment && (
            <div><strong style={{ color: '#C87400' }}>PROOF</strong> &nbsp;<span style={{ wordBreak: 'break-all', fontSize: '11px' }}>{form.proofOfComment}</span></div>
          )}
        </div>
      </div>

      <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '11px', color: '#8B6914', marginBottom: '18px', lineHeight: '1.5' }}>
        🔒 Your data is stored securely and used only to allocate your whitelist spot.
        We will <strong>never</strong> ask for your seed phrase or private key.
      </p>

      <button
        className="wl-btn-primary"
        onClick={submit}
        disabled={loading || submitted}
        style={{
          width: '100%', padding: '16px',
          background: submitted
            ? 'linear-gradient(160deg, #5A8A00, #4A7200)'
            : loading
              ? 'rgba(61,31,10,0.2)'
              : 'linear-gradient(160deg, #C87400, #A85E00)',
          border: '3px solid #3D1F0A', borderRadius: '12px',
          color: submitted || !loading ? '#F5EDD6' : '#8B6914',
          fontSize: '18px', fontWeight: '900',
          fontFamily: "'Bangers', cursive", letterSpacing: '2px',
          textTransform: 'uppercase',
          cursor: loading || submitted ? 'not-allowed' : 'pointer',
          transform: submitted || loading ? 'none' : 'skewX(-4deg)',
          boxShadow: submitted ? '0 4px 0 #2A5000' : loading ? 'none' : '0 6px 0 #7A4A00',
          opacity: loading ? 0.65 : 1, transition: 'all 0.12s ease',
        }}
      >
        <span style={{ display: 'inline-block', transform: submitted || loading ? 'none' : 'skewX(4deg)' }}>
          {loading ? 'SUBMITTING...' : submitted ? '✓ SUBMITTED!' : 'CONFIRM & SUBMIT →'}
        </span>
      </button>

      {status && (
        <p style={{
          marginTop: '14px', textAlign: 'center',
          fontFamily: "'Nunito', sans-serif", fontSize: '13px', fontWeight: '800',
          color: submitted ? '#5A8A00' : '#B33000',
        }}>
          {status}
        </p>
      )}
    </div>
  );
}
